export default (that) => [
  {
    text: that.$l('menu_text_passed') || '审核通过',
    icon: 'el-icon-check',
    menuType: 'passed',
    divided: false,
    allow: 'P',
  },
  {
    text: that.$l('menu_text_rejected') || '审核驳回',
    icon: 'el-icon-refresh-left',
    menuType: 'rejected',
    divided: false,
    allow: 'R',
  },
]
